export default "__VITE_ASSET__Bipmjw1e__"